
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Projects() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const projects = [
    {
      image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/4f08ee9884cedc1663e10982a3475263.png',
      title: 'Esquadrias de Alumínio',
      excerpt: 'Descubra as Vantagens das Esquadrias de Alumínio As esquadrias de alumínio são uma ótima escolha para quem busca durabilidade, estética e economia',
    },
    {
      image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/af1061729036f4211179a757ff71389f.png',
      title: 'Possibilidades de Personalização',
      excerpt: 'Opções de Personalização As esquadrias de alumínio são uma opção popular para janelas, portas e fachadas devido à sua durabilidade, resistência à',
    },
    {
      image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/4b7edd41a87693da7297b51c3ff2e220.png',
      title: 'Escolhendo o Melhor Guarda-Corpo',
      excerpt: 'A escolha do guarda-corpo ideal é fundamental para a sua obra Existem diversos tipos de guarda-corpos disponíveis no mercado, cada um com',
    },
  ];

  return (
    <section ref={sectionRef} className="py-12 md:py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-2 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="h-44 md:h-56 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                  {project.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                  {project.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Ver Mais Projetos */}
        <div className={`text-center mt-10 md:mt-12 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} transition-all duration-700`} style={{ transitionDelay: '450ms' }}>
          <Link
            to="/galeria"
            className="inline-flex items-center gap-2 bg-[#010E31] hover:bg-[#0a1f4d] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-gallery-line text-xl"></i>
            Ver Todos os Projetos
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
